<template>
    <div>
        <div style="text-align: center" v-if="editable == true">
            <div style="font-weight: bold;font-size: 15px" v-if="showFile">{{fileName}}</div>
            <input
                    type="file"
                    :accept="accept"
                    style="padding: 30px; border:1px dashed gray; margin: 10px; width:90%;height: 100px"
                    @change="onFilePicked"
            />
        </div>
        <!-- <v-btn small class="yoprimary" dark fab @click="zoomIn" title="zoom in">
          <v-icon dark>zoom_in</v-icon>
        </v-btn>
        <v-btn small class="orange" dark fab @click="zoomOut" title="zoom out">
          <v-icon dark>zoom_out</v-icon>
        </v-btn> -->
        <div v-if="showFile">
            <img
                    style="width:100%;padding:10px"
                    :src="attachPath"
                    v-if="fileType != null && fileType.indexOf('image/')>=0"
            />
            <div v-else-if="fileType != null">
                <!--div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center" :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div-->
                <pdf :src="attachPath"
                     v-for="i in numPages"
                     :key="i"
                     :page="i"
                     @password="password"
                     @error="error"
                     style="width: 100%;padding: 10px"
                     @num-pages="pageLoad($event)"
                />
                <!--pdf v-if="show" ref="pdf" style="border: 1px solid red" :src="src"
                     :page="page"
                     :rotate="rotate"
                     @password="password"
                     @progress="loadedRatio = $event"
                     @error="error"
                     @num-pages="numPages = $event" @link-clicked="page = $event"></pdf-->

                <!--div style="text-align: center">
                    <a class="quizQuestion" v-for="i in numPages" :key="i" @click="currentPage = i">{{i}}</a>
                </div-->

            </div>
        </div>
    </div>
</template>

<script>
    import {message} from "../../services";
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios";
    import IUpload from "../../components/form/Upload";
    import pdf from "vue-pdf";

    export default {
        name: "file-view",
        components: {
            pdf,
            IUpload,
            IDatepicker
        },

        props: {
            editable: {
                type: Boolean,
                default: () => {
                    return true;
                }
            },
            accept: {
                type: String,
                default: () => {
                    return "*.*";
                }
            },
            attachType: {
                type: String,
                default: () => {
                    return null;
                }
            },
            attachId: {
                type: Number | String,
                default: () => {
                    return null;
                }
            },
            showFile: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                scale: 1,
                fileName: "",
                numPages: 0,
                currentPage: 1,
                attachPath: "",
                pdfSource: null,
                fileType: "",
                loadedRatio:0,
                loadSuccess:false,
                loadCount:0,
            };
        },

        watch: {
            attachType: function (data) {
                console.log("--- attachType change ---");
                console.log(data);
                this.fileType = data;
            },
            attachId: function (data) {
                console.log("--- attachId change ---");
                //console.log(data);
                this.currentPage = 1;
                this.pdfSource = null;
                this.numPages = 0;
                this.attachId = data;
                this.loadCount = 0;
                this.$nextTick(() => {
                    this.viewFile(data);
                })
            }
        },

        created() {
            console.log("--- created fileView ---");
            //console.log(this.attachType);
            //console.log(this.editable);
            this.fileType = this.attachType;
            console.log(this.pdfSource);
            console.log(this.numPages);
            this.viewFile(this.attachId);
        },

        computed: {},

        methods: {
            password: function(updatePassword, reason) {
                updatePassword(prompt('Nhập mật khẩu:'));
            },

            viewFile(attachId) {
                this.loadSuccess = false;
                this.loadCount++;
                //console.log(this.fileType);
                if (this.fileType == null) {
                    return;
                }
                if (attachId == null) {
                    return;
                }
                if (this.fileType.indexOf("image/") >= 0) {
                    this.attachPath =
                        process.env.VUE_APP_API_URL + "/download/attach/" + attachId;
                } else {
                    if (attachId == undefined || attachId == null) {
                        this.attachPath = null;
                        return;
                    }
                    this.attachPath = process.env.VUE_APP_API_URL + "/download/attach/" + attachId;
                    /*
                                        axios.get(this.attachPath).then (
                                            response =>{
                                                const blob = new Blob([response.data]);
                                                const objectUrl = URL.createObjectURL(blob);
                                                this.pdfSource = pdf.createLoadingTask(objectUrl);
                                                this.pdfSource.then(pdf => {
                                                    this.currentPage = 1;
                                                    this.numPages = pdf.numPages;
                                                    console.log(pdf);
                                                    console.log("--- numpages ---");
                                                    console.log(this.numPages);
                                                });                        }
                                        )
                    */
                    //console.log("--- attach path ---");
                    console.log(this.attachPath);
                    this.pdfSource = pdf.createLoadingTask(
                        this.attachPath
                    );
                    this.pdfSource.then(pdf => {
                        console.log("load success");
                        this.loadSuccess = true;
                        this.loadCount = 0;
                        this.currentPage = 1;

                        this.numPages = pdf.numPages;
/*
                        console.log(pdf);
                        console.log("--- numpages ---");
                        console.log(this.numPages);
*/
                    });
                    if(this.loadCount<3) {
                        setTimeout(
                            () => {
                                console.log(this.loadSuccess);
                                if (!this.loadSuccess) {
                                    this.attachPath = "";
                                    this.$nextTick(
                                        () => {
                                            console.log("next tick");
                                            this.viewFile(this.attachId);
                                        }
                                    )
                                }

                            },
                            1000 * this.loadCount
                        )
                    }
                }
            },

            zoomIn: function () {
                this.scale += this.scale < 2 ? 0.1 : 0;
                console.log(this.scale);
            },

            error(message) {
                console.log("render pdf error");
                console.log(message);
            },

            pageLoad(numPage) {
/*
                console.log("page loaded: " + numPage);
                console.log("path loaded: " + this.attachPath);
                if (numPage == undefined || numPage == null) {
                    if (this.attachPath != undefined && this.attachPath != null && this.attachPath != "") {
                        this.loadCount++;
                        if(this.loadCount>3){
                            return;
                        }
                        setTimeout(()=>{
                            //console.log("after 3s");
                            if(!this.loadSuccess) {
                                this.attachPath = "";
                                this.$nextTick(
                                    () => {
                                        //console.log("next tick");
                                        this.viewFile(this.attachId);
                                    }
                                )
                            }
                        },1000);
                    }
                } else {
                    this.numPages = numPage;
                    this.loadSuccess = true;
                    //console.log("page loaded: " + this.numPages);
                }
*/
            },

            zoomOut: function () {
                this.scale -= this.scale > 0.2 ? 0.1 : 0;
                console.log(this.scale);
            },

            uploadFile: function (e) {
                let formData = new FormData();
                formData.append("uploadfile", this.fileContent);
                formData.append("sourceId", "");
                formData.append("sourceType", "1");
                formData.append("attachTitle", "");
                axios
                    .post(process.env.VUE_APP_API_URL + "/upload/save", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(
                        data => {
                            if (data.success) {
                                console.log("after upload");
                                data.type = this.fileType;
                                data.fileName = this.fileName;
                                this.viewFile(data.id);
                                this.$emit("change", data);
                                message.success("upload thành công");
                            } else {
                                message.success("upload không thành công");

                            }
                        },
                        error => {
                            message.error("upload không thành công");
                            e.target.value = "";
                            this.fileName = "";
                        }
                    );
            },

            onFilePicked: function (e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    //console.log(files[0]);
                    this.fileName = files[0].name;
                    this.fileType = files[0].type;
                    if (this.fileName.lastIndexOf(".") <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener("load", () => {
                        this.fileURL = fr.result;
                        this.fileContent = files[0]; // this is an file that can be sent to server...
                        this.uploadFile(e);
                    });
                }
            }
        }
    };
</script>

